let clipboard_events = 
{
    create_clipboard_event(event_data)
    {
        var old_events = this.check_clipboard_events('events');
        var new_event =  
        {
            id:                         event_data.id,
            date:                       event_data.date,
            vip:                        event_data.vip,
            allergy:                    event_data.allergy,
            fullpayment:                event_data.fullpayment,
            banned:                     event_data.banned,
            book_status:                event_data.book_status,
            name:                       event_data.name,
            start_time:                 event_data.start_time,
            end_time:                   event_data.end_time,
            service:                    event_data.service,
            booking_notes:              event_data.booking_notes,
            last_visit_count:           event_data.last_visit_count,
            clipboard_event_flag:       event_data.clipboard_event_flag
        }
        var index = old_events.findIndex(x => x.id == new_event.id)
        if (index === -1)
        {
            old_events.push(new_event)
            sessionStorage.setItem("droped_event", JSON.stringify(old_events));
            return true;
        }
        return false;
    },
    check_clipboard_events(data_required)
    {
        var events_list = JSON.parse(sessionStorage.getItem('droped_event')) || []
        if(data_required == 'length')  return events_list.length;
        else if(data_required == 'events') return events_list;
        else return null; 
    },

    removeEventFromClipboard(info) {
        var old_events = this.check_clipboard_events('events');
        var removeIndex = old_events.map(function(item) { return item.id; }).indexOf(info.event.id);
        old_events.splice(removeIndex, 1);
        sessionStorage.setItem("droped_event", JSON.stringify(old_events));
        return old_events;
    },
}
export default clipboard_events